
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { moneyFormatter } from "@/components/utils";
import {
  calcular_preco_quantidade_minima,
  calcular_quantidade_unidade_medida,
} from "../../services/ProdutosService";

@Component({
  name: "ProdutoInfoDialog",
})
export default class ProdutoInfoDialog extends Vue {
  private dlgVisible = false;
  private descontos = [] as Array<any>;
  private internalProduto = {} as any;

  public show(produto: any, descontos?: any) {
    this.descontos = [] as Array<any>;

    this.internalProduto = JSON.parse(JSON.stringify(produto));

    this.dlgVisible = true;

    if (descontos) {
      descontos.forEach((element) => {
        this.descontos.push({
          percentual: `${+element.percDesconto}% de Desconto`,
          quantidade: `Na compra de ${+element.qtdeMin} unidades`,
          preco: moneyFormatter(Number(
            (this.internalProduto.promocao?.[0]?.precoUnit ||
              this.internalProduto?.precosVenda?.[0]?.precoUnit) *
              (1 - +element.percDesconto / 100) || 0
          ).toFixed(2)),
        });
      });
    }
  }

  @Watch("dlgVisible")
  onDlgClosedByEscKey(value: boolean, oldValue: boolean) {
    if (value === false) this.onFecharClick();
  }

  onFecharClick() {
    this.dlgVisible = false;
    this.$emit("fechar");
  }
}
